import {useState} from 'react';
import "../signup.css";

export const CreditCard = ({updateCustomer, returnToInformation}) => {
  const [errors, setErrors] = useState('');
  const returnClick = () => {
    returnToInformation();
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    const name = document.getElementById('cardName');
    if (name.value) {
        var additionalData = {
            name: name.value
        }
        window.stripeObj.createToken(window.cardNumber, additionalData).then((result) => {
            console.log(result)
            if (result.token) {
              updateCustomer(result.token.id);
            } else if (result.error) {
              setErrors(result.error.message);
            }
        });
    }

  };

  return (
      <div>
                    <div className="approvalCardReturn" onClick={() => returnToInformation()}>
                    &lt; Return to information
                    </div>

                    <div className="approvalCardSection" >
                        <div className="approvalCardHeaderRow" >
                            <div className="approvalCardText" >
                            <h4>Card on file</h4>
                            </div>
                        </div>

                        <div className="approvalCardSubHeaderRow" >
                            <div className="approvalCardText approvalCardTextSub" >
                            We ask for your card info now to make order easy.
                            You will not be charged unless you place an order.
                            </div>

                            <div className="approvalCards">
                                <img alt="Visa" src="/images/signup/icon_visa.svg"/>
                                <img alt="MasterCard" src="/images/signup/icon_mc.svg"/>
                                <img alt="American Express" src="/images/signup/icon_amx.svg"/>
                                <img alt="Discover" src="/images/signup/icon_disc.svg"/>
                            </div>
                        </div>
                        <div className="approvalCardNumberRow" >
                            <div className="approvalCardNumber" >
                                <div id="approvalCardNumberLabel" className="approvalCardNumberLabel" >
                                Card number
                                </div>
                                <div className="approvalCardNumberEntry" id="cardNumber" ></div>
                            </div>
                        </div>
                        <div className="approvalCardNameRow" >
                            <div className="approvalCardName" >
                                <div id="approvalCardNameLabel" className="approvalCardNameLabel" >
                                Name on card
                                </div>
                                <input id="cardName" type="text" className="approvalCardNameEntry"  placeholder="Name on card"/>
                            </div>
                        </div>
                        <div className="approvalCardExpirationRow" >
                            <div className="approvalCardExpiration" >
                                <div id="approvalCardExpirationLabel" className="approvalCardExpirationLabel" >
                                Expiration date (MM/YY)
                                </div>
                                <div className="approvalCardExpirationEntry" id="expirationDate" ></div>
                            </div>
                            <div className="approvalCardSecurityCode" >
                                <div id="approvalCardSecurityCodeLabel" className="approvalCardSecurityCodeLabel" >
                                Security code
                                </div>
                                <div className="approvalCardSecurityCodeEntry" id="securityCode" ></div>
                            </div>
                        </div>
                        { errors &&
                            <div className="approvalCardErrors">{errors}</div>
                        }
                        <div className="approvalCardSubtextRow" >
                        *Card info stored securely in Stripe.
                        </div>

                        <div className="approvalSubscriptionCheck" >
                            <div>
                                <input type="checkbox" checked/>
                            </div>
                            <div className="approvalSubscriptionText" >
                            <p>You agree to our <a href="/termsofuse">Terms of Use</a> and <a href="/privacypolicy">Privacy Policy</a>. You consent to receive text messages from Fellow. Message & data rates apply. You understand you can opt out anytime by replying STOP.</p>
                            </div>
                        </div>
                    </div>

                <div className="approvalSubmitSection">
                    <div className="approvalSubmitButton" id="signUpSubmit" onClick={onSubmit} >
                        <div className="approvalSubmitButtonText" >Sign Up</div>
                    </div>
                </div>
    </div>
  );
}
